import {API, ApiRequestOptions} from '@/classes/api/api.class';
import {FindAddressRequestDto} from '@/classes/dto/geocoder/request/FindAddress.request.dto';
import {FindAddressResponseDto} from '@/classes/dto/geocoder/response/FindAddress.response.dto';

export class GeocoderAPI extends API {
    static service = 'geocoder';

    /** options: e.g. handledStatuses – the caller shows its own hint instead of the error dialog (Lehrkraft-Bereich) */
    static findAddress(data: FindAddressRequestDto, options?: ApiRequestOptions): Promise<FindAddressResponseDto> {
        return this.get(`address`, data, undefined, options);
    }
}
